module.exports = "../../personal-portfolio.JPG";